const HeaderData = [
    {
          title: 'Unser Angebot',
          link:"/#unserangebot"
    },
    {
        title: 'Events',
        link:"/#eventzeitplan"
  },
  {
    title: 'Galerie',
    link:"/#galerie"
},
{
    title: 'Kontakt',
    link:"/#kontakt"
},
   
]

export default HeaderData